import type { RouteRecordRaw } from 'vue-router';

export type Routes = RouteRecordRaw & {
  sitemap?: boolean;
};

const cruisesRoutes: Routes[] = [
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "MainPage" */ '@/pages/cruises/MainPage.vue'),
    sitemap: true,
  },
  {
    path: '/order-status/:order_id',
    component: () =>
      import(
        /* webpackChunkName: "OrderStatusPage" */ '@/pages/OrderStatusPage.vue'
      ),
    props: true,
  },
  {
    name: 'cruisesListPage',
    path: '/vyhledat/',
    component: () =>
      import(/* webpackChunkName: "ListPage" */ '@/pages/cruises/ListPage.vue'),
    sitemap: true,
  },
  {
    name: 'cruisesListPageLuxury',
    path: '/luxusni-plavby/',
    component: () =>
      import(/* webpackChunkName: "ListPage" */ '@/pages/cruises/ListPage.vue'),
    props: { pageType: 'luxury' },
    sitemap: true,
  },
  {
    name: 'cruisesListPagePromo',
    path: '/akcni-plavby/',
    component: () =>
      import(/* webpackChunkName: "ListPage" */ '@/pages/cruises/ListPage.vue'),
    props: { pageType: 'promo' },
    sitemap: true,
  },
  {
    name: 'cruisesListPageDestination',
    path: '/destinace/:destination/',
    component: () =>
      import(/* webpackChunkName: "ListPage" */ '@/pages/cruises/ListPage.vue'),
    sitemap: true,
  },
  {
    name: 'cruisesListPageCompany',
    path: '/spolecnost/:companyCode/',
    component: () =>
      import(/* webpackChunkName: "ListPage" */ '@/pages/cruises/ListPage.vue'),
    sitemap: true,
  },
  {
    name: 'cruisesDetailPage',
    path: '/detail/:cruise_code/',
    component: () =>
      import(
        /* webpackChunkName: "DetailPage" */ '@/pages/cruises/DetailPage.vue'
      ),
    props: true,
    sitemap: true,
  },
  {
    path: '/rezervace/:cruise_code/dokoncena/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationDonePage" */ '@/pages/cruises/ReservationDonePage.vue'
      ),
  },
  {
    path: '/rezervace/:cruise_code/kajuta/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationCabinPage" */ '@/pages/cruises/ReservationCabinPage.vue'
      ),
  },
  {
    path: '/rezervace/:cruise_code/shrnuti/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationSummaryPage" */ '@/pages/cruises/ReservationSummaryPage.vue'
      ),
    props: true,
  },
  {
    path: '/rezervace/:cruise_code/platba/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationPaymentPage" */ '@/pages/cruises/ReservationPaymentPage.vue'
      ),
  },
  {
    path: '/rezervace/:cruise_code/kajuta-a-ubytovaci-balicek/',
    name: 'cruiseReservationPackage',
    component: () =>
      import(
        /* webpackChunkName: "ReservationPackagePage" */ '@/pages/cruises/ReservationPackagePage.vue'
      ),
  },
  {
    path: '/rezervace/:cruise_code/doprava/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationTransportPage" */ '@/pages/cruises/ReservationTransportPage.vue'
      ),
  },
  {
    path: '/rezervace/:cruise_code/nenalezeno/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationNotFoundPage" */ '@/pages/cruises/ReservationNotFoundPage.vue'
      ),
  },
  {
    path: '/rezervace/:cruise_code/bez-kajut/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationNoCabinsPage" */ '@/pages/cruises/ReservationNoCabinsPage.vue'
      ),
  },
  {
    path: '/rezervace/:cruise_code/neprihlaseny-uzivatel/',
    component: () =>
      import(
        /* webpackChunkName: "ReservationNotLoggedPage" */ '@/pages/cruises/ReservationNotLoggedPage.vue'
      ),
    props: true,
  },
  {
    path: '/prihlaseni/',
    component: () =>
      import(/* webpackChunkName: "LoginPage" */ '@/pages/LoginPage.vue'),
  },
  {
    path: '/registrace/',
    component: () =>
      import(
        /* webpackChunkName: "RegistrationPage" */ '@/pages/RegistrationPage.vue'
      ),
  },
  {
    path: '/zapomenute-heslo/',
    component: () =>
      import(
        /* webpackChunkName: "ForgottenPasswordPage" */ '@/pages/ForgottenPasswordPage.vue'
      ),
  },
  {
    path: '/obnovit-heslo/:recovery_token/',
    component: () =>
      import(
        /* webpackChunkName: "RecoverPasswordPage" */ '@/pages/RecoverPasswordPage.vue'
      ),
    props: true,
  },
  {
    path: '/uzivatel/',
    component: () =>
      import(/* webpackChunkName: "UserPage" */ '@/pages/UserPage.vue'),
  },
  {
    path: '/nastaveni-uctu/',
    component: () =>
      import(
        /* webpackChunkName: "AccountSettingsPage" */ '@/pages/AccountSettingsPage.vue'
      ),
  },
  {
    name: 'contentPage',
    path: '/kontent/:contentPageName/',
    component: () =>
      import(/* webpackChunkName: "ContentPage" */ '@/pages/ContentPage.vue'),
    props: true,
    sitemap: true,
  },
  {
    path: '/lod/:shipCode',
    name: 'cruiserPage',
    component: () =>
      import(
        /* webpackChunkName: "CruiserPage" */ '@/pages/cruises/CruiserPage.vue'
      ),
    props: true,
    sitemap: true,
  },
  {
    name: 'cruisesForFirms',
    path: '/pro-firmy/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesForFirms" */ '@/pages/content/CruisesForFirms.vue'
      ),
    sitemap: true,
  },
  {
    name: 'cruisesForGroups',
    path: '/pro-skupiny/',
    component: () =>
      import(
        /* webpackChunkName: "vue" */ '@/pages/content/CruisesForGroups.vue'
      ),
    sitemap: true,
  },
  {
    path: '/kontakt/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesContact" */ '@/pages/content/CruisesContact.vue'
      ),
    sitemap: true,
  },
  {
    name: 'cruisesHowItWorksCosta',
    path: '/jak-to-funguje-costa/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesHowItWorksCosta" */ '@/pages/content/CruisesHowItWorksCosta.vue'
      ),
    sitemap: true,
  },
  {
    name: 'cruisesHowItWorksMSC',
    path: '/jak-to-funguje-msc/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesHowItWorksMSC" */ '@/pages/content/CruisesHowItWorksMSC.vue'
      ),
    sitemap: true,
  },
  {
    path: '/plavba-na-jachte/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesYacht" */ '@/pages/content/CruisesYacht.vue'
      ),
    sitemap: true,
  },
  {
    name: 'cruisesCosta',
    path: '/costa-cruises/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesCosta" */ '@/pages/content/CruisesCosta.vue'
      ),
    sitemap: true,
  },
  {
    name: 'cruisesMSC',
    path: '/msc-cruises/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesMSC" */ '@/pages/content/CruisesMSC.vue'
      ),
    sitemap: true,
  },
  {
    path: '/yachtas-coffee/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesYachtasCoffee" */ '@/pages/content/CruisesYachtasCoffee.vue'
      ),
    sitemap: true,
  },
  // Plavby s delegátem
  {
    name: 'cruisesDelegateListPage',
    path: '/plavby-s-delegatem/',
    component: () =>
      import(
        /* webpackChunkName: "ListPage" */ '@/pages/cruises-delegate/ListPage.vue'
      ),
    sitemap: true,
  },
  {
    path: '/plavba-s-delegatem/:special_cruise_code/',
    component: () =>
      import(
        /* webpackChunkName: "DetailPage" */ '@/pages/cruises-delegate/DetailPage.vue'
      ),
    props: true,
    sitemap: true,
  },
  {
    path: '/plavba-s-delegatem-objednavka/:cruise_code/',
    component: () =>
      import(
        /* webpackChunkName: "OrderFormPage" */ '@/pages/cruises-delegate/OrderFormPage.vue'
      ),
    props: true,
  },
  {
    path: '/plavba-s-delegatem/:cruise_code/nenalezeno/',
    component: () =>
      import(
        /* webpackChunkName: "NotFoundPage" */ '@/pages/cruises-delegate/NotFoundPage.vue'
      ),
  },
  {
    path: '/plavba-s-delegatem-odeslano/',
    component: () =>
      import(
        /* webpackChunkName: "OrderFormDone" */ '@/pages/cruises-delegate/OrderFormDone.vue'
      ),
  },
  {
    name: 'cruisesDestinations',
    path: '/destinace/',
    component: () =>
      import(
        /* webpackChunkName: "CruisesDestinations" */ '@/pages/cruises/Destinations.vue'
      ),
    sitemap: true,
  },
  {
    path: '/:notFound(.*)*',
    redirect: '/',
  },
];

export { cruisesRoutes };
